import * as React from 'react';
import styled from 'styled-components';
import { FlexCol, FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { rem } from 'polished';
import { Button } from '../../General/Button';
import { OutsideClick } from '../../../Defaults/OutsideClick';
import { MiniCartItem } from './MiniCartItem';
import { __ } from 'react-i18n/lib';
import {
  prop,
  getSymbolFromCurrency,
  formatPrice,
} from '../../../../utilities';
import {
  getProductDefaultInfo,
  getCartSummaryInfo,
} from '../../../../utilities/selectors';

/*****************/
const Wrapper = styled(FlexCol)`
  background: ${({ theme }) => theme.color.white};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};

  width: ${rem(400)};
  border-radius: ${rem(4)};
  max-height: ${rem(600)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const ItemsWrapper = styled(FlexCol)`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: ${rem(16)};
`;

const EmptyCart = styled.div`
  padding: ${rem(16)};
`;

const TotalPriceWrapper = styled.div`
  border-top: ${({ theme }) => theme.borders.banners};
  padding-top: ${rem(16)};
  margin-left: -${rem(16)};
  margin-right: -${rem(16)};
  padding: ${rem(16)};
`;

const TotalPrice = styled(FlexRow)`
  justify-content: space-between;
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  margin-bottom: ${rem(24)};
  padding: 0 ${rem(16)};
`;

const TotalPriceText = styled.div``;
const Price = styled.div`
  font-weight: 500;
`;

const StyledButton = styled(Button)`
  margin: ${rem(16)};
  margin-top: 0;
  // margin-bottom: ${rem(24)};
`;

interface Props {
  cartData: any;
  handleToCartButtonClick: any;
  handleRemoveFromCartButtonClick: any;
  handleCountChange: any;
  user: any;
}

class MiniCart extends React.Component<Props> {
  public render() {
    const {
      cartData,
      handleToCartButtonClick,
      handleRemoveFromCartButtonClick,
      handleCountChange,
      user,
    } = this.props;
    const { totalPrice, currency, lang } = getCartSummaryInfo(cartData);
    const { items } = cartData || [];
    const isB2B = user && user.b2b;
    return (
      <Wrapper>
        {items && items.length > 0 ? (
          <>
            <ItemsWrapper>
              {items.map((item: any, i) => {
                return (
                  <React.Fragment key={prop(item, 'good.good_id')}>
                    <MiniCartItem
                      item={item}
                      handleRemoveClick={handleRemoveFromCartButtonClick}
                      handleCountChange={handleCountChange}
                    />
                    {prop(item, 'sale_count') > 0 && (
                      <MiniCartItem
                        item={item}
                        handleRemoveClick={handleRemoveFromCartButtonClick}
                        handleCountChange={handleCountChange}
                        isActionSale={true}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </ItemsWrapper>
            <TotalPriceWrapper>
              <TotalPrice>
                {__('Spolu s DPH')}
                <Price>
                  {formatPrice(
                    totalPrice || 0,
                    currency,
                    2,
                    false,
                    '',
                    false,
                    lang === 'cz' && !isB2B ? 0 : 2,
                  )}
                </Price>
              </TotalPrice>
            </TotalPriceWrapper>
            <StyledButton onClick={handleToCartButtonClick}>
              {__('Prejsť do košíka')}
            </StyledButton>
          </>
        ) : (
          <EmptyCart>{__('Váš nákupný košík je prázdny')}</EmptyCart>
        )}
      </Wrapper>
    );
  }
}

export { MiniCart };
